import { LayerProxy } from "./LayerProxy.js";

export { WmsProxy };

class WmsProxy extends LayerProxy {

    constructor() {
        super();

        this.params = {};
    }

    setParams(params) {
        const changed = _.cloneDeep(params);

        for (let key in this.params) {
            if (!(key in changed)) {
                changed[key] = null;
            }
        }

        this.params = _.cloneDeep(params);

        return changed;
    }

    getParams() {
        return _.cloneDeep(this.params);
    }

    setLayers() {}
    setZIndex(zIndex) { }
}